var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        id: "keyboard_navigation",
        horizontal: "",
        "label-cols": "3",
        "label-size": "md",
        label: _vm.$t("labels.kbnav") + ":"
      }
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "Non-strict" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected,
                      expression: "selected"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "Non-strict",
                    name: "selected",
                    value: "Non-strict"
                  },
                  domProps: { checked: _vm._q(_vm.selected, "Non-strict") },
                  on: {
                    change: function($event) {
                      _vm.selected = "Non-strict"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("labels.knavHover")))])
              ]
            )
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "Strict" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selected,
                      expression: "selected"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "Strict",
                    name: "selected",
                    value: "Strict"
                  },
                  domProps: { checked: _vm._q(_vm.selected, "Strict") },
                  on: {
                    change: function($event) {
                      _vm.selected = "Strict"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("labels.knavNormal")))])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Settings/kbNav.vue?vue&type=template&id=036877db&
// module id = null
// module chunks = 